import {RouteConfig} from 'vue-router';

import ExternalReportsStandard from '@/components/ExternalReports/Standard/index.vue';
import PrintExternalReportsStandardReport from '@/components/ExternalReports/Standard/ReportPrint/index.vue';
import SpExternalReportsStandardReport from '@/components/Sp/ExternalReports/Standard/index.vue';
import ExternalReportsHokkaidoAirport from '@/components/ExternalReports/HokkaidoAirport/index.vue';
import SpExternalReportsHokkaidoAirportReport from '@/components/Sp/ExternalReports/HokkaidoAirport/index.vue';
import PrintExternalHokkaidoAirportReport from '@/components/ExternalReports/HokkaidoAirport/ReportPrint/index.vue';
import ExternalReportsEmergencyResponseTeam from '@/components/ExternalReports/EmergencyResponseTeam/index.vue';
import PrintExternalReportsEmergencyResponseTeamReport from '@/components/ExternalReports/EmergencyResponseTeam/ReportPrint/index.vue';
import SpExternalReportsEmergencyResponseTeamReport from '@/components/Sp/ExternalReports/EmergencyResponseTeam/index.vue';

export const externalReportRoutes: RouteConfig[] = [
  {
    path: '/external-map/standard',
    name: 'ExternalReportsStandard',
    component: ExternalReportsStandard,
  },
  {
    path: '/print-external-report/standard/:externalReportId',
    name: 'PrintExternalReportsStandardReport',
    component: PrintExternalReportsStandardReport,
  },
  {
    path: '/print-external-report/standard/:dateFrom/:dateTo/:hanName/:currentPage/:itemsPerPage',
    name: 'PrintExternalReportsStandardReportAll',
    component: PrintExternalReportsStandardReport,
  },
  {
    path: '/external-map/hokkaido-airport',
    name: 'ExternalReportsHokkaidoAirport',
    component: ExternalReportsHokkaidoAirport,
  },
  {
    path: '/external-map/emergency-response-team',
    name: 'ExternalReportsEmergencyResponseTeam',
    component: ExternalReportsEmergencyResponseTeam,
  },
  {
    path: '/print-external-report/emergency-response-team/:externalReportId',
    name: 'PrintExternalReportsEmergencyResponseTeamReport',
    component: PrintExternalReportsEmergencyResponseTeamReport,
  },
  {
    path: '/print-external-report/emergency-response-team/:dateFrom/:dateTo/:hanName/:currentPage/:itemsPerPage',
    name: 'PrintExternalReportsEmergencyResponseTeamReportAll',
    component: PrintExternalReportsEmergencyResponseTeamReport,
  },
  {
    path: '/print-external-report/hokkaido-airport/:externalReportId',
    name: 'PrintExternalHokkaidoAirportReport',
    component: PrintExternalHokkaidoAirportReport,
  },
  {
    path: '/print-external-report/hokkaido-airport/:dateFrom/:dateTo/:hanName/:currentPage/:itemsPerPage',
    name: 'PrintExternalHokkaidoAirportReportAll',
    component: PrintExternalHokkaidoAirportReport,
  },
];

export const spExternalReportRoutes: RouteConfig[] = [
  {
    path: '/sp/external-reports/standard',
    name: 'SpExternalReportsStandardReport',
    component: SpExternalReportsStandardReport,
  },
  {
    path: '/sp/external-reports/hokkaido-airport',
    name: 'SpExternalReportsHokkaidoAirportReport',
    component: SpExternalReportsHokkaidoAirportReport,
  },
  {
    path: '/sp/external-reports/emergency-response-team',
    name: 'SpExternalReportsEmergencyResponseTeamReport',
    component: SpExternalReportsEmergencyResponseTeamReport,
  },
];
